import React from 'react';
import { User } from 'lucide-react';

interface UserInfoProps {
    email: string;
    className?: string;
}

export default function UserInfo({ email, className = '' }: UserInfoProps) {
    return (
        <div className={`px-4 py-2 bg-white/5 backdrop-blur-md rounded-lg border border-white/10 ${className}`}>
            <div className="flex items-center justify-center gap-2 text-white/90">
                <User className="w-4 h-4 text-blue-300" />
                <span className="text-xs text-white/60">Logged in as:</span>
                <span className="text-sm font-medium text-blue-300">{email}</span>
            </div>
        </div>
    );
}
